import {
    BOOKING_LIST_REQUEST,
    BOOKING_LIST_SUCCESS,
    BOOKING_REQUEST,
    BOOKING_SUCCESS,
    BOOKING_CANCEL_REQUEST,
    BOOKING_CANCEL_SUCCESS,
    BOOKING_CHANGE_APPOINTMENT_REQUEST,
    BOOKING_CHANGE_APPOINTMENT_SUCCESS,
    BOOKING_UPDATE_STATUS_REQUEST,
    BOOKING_UPDATE_STATUS_SUCCESS,
    BOOKING_ERROR,
    BOOKING_SETTINGS_CANCEL_REASONS_REQUEST,
    BOOKING_SETTINGS_CANCEL_REASONS_SUCCESS,
  } from '@/store/actions/booking';
  import { BookingService } from '@/common/api';
  import { languages } from '@/common/api/config';
  import BookingItemModel from '@/model/booking/bookingItem';
  import BookingDetailModel from '@/model/booking/bookingDetail';
  import { ERROR, SUCCESS } from '@/store/actions/ui';
  
  const state = {
    page: 0,
    pages: 0,
    count: 0,
    list: [],
    item: null,
    settingsCancelReasons: [],
    rating: null,
    bookings: null,
    booking: null,
    loading: false,
    loadingItem: false,
    language: languages[0],
  };
  
//   const limit = 15;
  
  const getters = {
    bookingList: (state) => state.list,
    bookingItem: (state) => state.item,
    bookingLoading: (state) => state.loading,
    bookingSettingsCancelReasons: (state) => state.settingsCancelReasons,
  };
  
  const actions = {
    [BOOKING_LIST_REQUEST]({ commit }, { token }) {
      // const offset = (page - 1) * limit;
      console.log('listBooking token', token);
      commit(BOOKING_LIST_REQUEST);
      return BookingService.listBooking(token).then((resp) => {
        commit(BOOKING_LIST_SUCCESS, resp);
        return resp;
      });
    },
    [BOOKING_SETTINGS_CANCEL_REASONS_REQUEST]({ commit }, { token }) {
      commit(BOOKING_SETTINGS_CANCEL_REASONS_REQUEST);
      return BookingService.getSettingsCancelReasons(token).then((resp) => {
        commit(BOOKING_SETTINGS_CANCEL_REASONS_SUCCESS, resp);
        return resp;
      });
    },
    [BOOKING_REQUEST]({ commit }, { token, bookingId }) {
      commit(BOOKING_REQUEST);
      return BookingService.getBooking(token, bookingId).then((resp) => {
        commit(BOOKING_SUCCESS, resp);
        return resp;
      });
    },
    [BOOKING_CHANGE_APPOINTMENT_REQUEST]({ commit, dispatch }, { token, bookingId, payload }) {
      commit(BOOKING_CHANGE_APPOINTMENT_REQUEST);
      return new Promise((resolve, reject) =>
        BookingService.changeAppointment(token, bookingId, payload)
          .then((resp) => {
            commit(BOOKING_CHANGE_APPOINTMENT_SUCCESS);
            resolve(resp);
            dispatch(SUCCESS, 'บันทึกสำเร็จ');
          })
          .catch((error) => {
            commit(BOOKING_ERROR);
            dispatch(ERROR, error);
            reject(error);
          }),
      );
    },
    [BOOKING_UPDATE_STATUS_REQUEST]({ commit, dispatch }, { token, bookingId, payload }) {
      commit(BOOKING_UPDATE_STATUS_REQUEST);
      return new Promise((resolve, reject) =>
        BookingService.updateStatus(token, bookingId, payload)
          .then((resp) => {
            commit(BOOKING_UPDATE_STATUS_SUCCESS);
            resolve(resp);
            dispatch(SUCCESS, 'บันทึกสำเร็จ');
          })
          .catch((error) => {
            commit(BOOKING_ERROR);
            dispatch(ERROR, error);
            reject(error);
          }),
      );
    },
    [BOOKING_CANCEL_REQUEST]({ commit, dispatch }, { token, bookingId, payload }) {
      commit(BOOKING_CANCEL_REQUEST);
      return new Promise((resolve, reject) =>
        BookingService.cancelBooking(token, bookingId, payload)
          .then((resp) => {
            commit(BOOKING_CANCEL_SUCCESS);
            resolve(resp);
            dispatch(SUCCESS, 'บันทึกสำเร็จ');
          })
          .catch((error) => {
            commit(BOOKING_ERROR);
            dispatch(ERROR, error);
            reject(error);
          }),
      );
    },
  };
  
  const mutations = {
    [BOOKING_LIST_REQUEST](state) {
      state.loading = true;
    },
    [BOOKING_LIST_SUCCESS](state, resp) {
      if (resp) {
        // state.list = resp.data.map(v => new BookingItemModel(v));
        state.list = resp.data;
        state.list.bookings = resp.data.bookings.map(v => new BookingItemModel(v));
      }
      state.loading = false;
    },
    [BOOKING_REQUEST](state) {
      state.loading = true;
    },
    [BOOKING_SUCCESS](state, resp) {
      if (resp) {
        state.item = new BookingDetailModel(resp.data);
      }
      state.loading = false;
    },
    [BOOKING_CHANGE_APPOINTMENT_REQUEST](state) {
      state.loading = true;
    },
    [BOOKING_CHANGE_APPOINTMENT_SUCCESS](state) {
      state.loading = false;
    },
    [BOOKING_UPDATE_STATUS_REQUEST](state) {
      state.loading = true;
    },
    [BOOKING_UPDATE_STATUS_SUCCESS](state) {
      state.loading = false;
    },
    [BOOKING_CANCEL_REQUEST](state) {
      state.loading = true;
    },
    [BOOKING_CANCEL_SUCCESS](state) {
      state.loading = false;
    },
    [BOOKING_ERROR](state) {
      state.loading = false;
    },
    [BOOKING_SETTINGS_CANCEL_REASONS_REQUEST](state) {
      state.loading = true;
    },
    [BOOKING_SETTINGS_CANCEL_REASONS_SUCCESS](state, resp) {
      if (resp) {
        state.settingsCancelReasons = resp?.data;
      }
      state.loading = false;
    },
  };
  
  export default {
    state,
    getters,
    actions,
    mutations,
  };
  